import { StyleSheet, View } from 'react-native'
import FocusAwareStatusBar from '../../Components/FocusAwareStatusBar'
import { WebView } from 'react-native-webview'
import { BASE_URL } from '../../config'
import { useNavigation } from '@react-navigation/native'
import { useLayoutEffect } from 'react'
import Header from '../../Components/Header'
import { useLocalisationContext } from '../../Providers/LocalisationProvider'


const TermsAndConditionsScreen = () => {

    const source = `${BASE_URL}/legal/terms-and-conditions`
    const navigation = useNavigation()
    const lang = useLocalisationContext()

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: false,
        })
    }, [])

    return (
        <View style={styles.container}>
            <FocusAwareStatusBar barStyle="dark-content" />
            <Header title={lang.t('terms_and_conditions')} />
            <WebView 
            style={styles.container}
            source={{ uri: source }}
            />
        </View>
    )
}

export default TermsAndConditionsScreen

const styles = StyleSheet.create({
    container: {
        flex: 1,
    }
})